import { makeStyles } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { ChipField, ListProps, ReferenceArrayField, SingleFieldList } from 'react-admin';
import AppEditButton from '../../../Components/ui/button/AppEditButton';
import AppDatagrid from '../../../Components/ui/datagrid/AppDatagrid';
import AppList from '../../../Components/ui/detail/AppList';
import AppTextField from '../../../Components/ui/field/AppTextField';
import AppTitle from '../../../Components/ui/layout/AppTitle';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      minWidth: theme.spacing(30),
    },
    section: {
      minWidth: theme.spacing(30),
    },
    lastCol: {
      width: '100%',
    },
  }),
  { name: 'LinksList' },
);

const IS_IVG = process.env.REACT_APP_IS_IVG === 'true';

const LinkList: FunctionComponent<ListProps> = (props) => {
  const classes = useStyles();

  return (
    <AppList {...props} title={<AppTitle title="Links" />}>
      <AppDatagrid resource="links" rowClick="show" permissions={props.permissions}>
        <AppTextField source="title" label="Titolo" headerClassName={classes.title} />
        <AppTextField source="section" label="Sezione" headerClassName={classes.section} />
        {!IS_IVG && (
          <ReferenceArrayField
            reference="properties"
            source="propertyIds"
            label="Siti"
            headerClassName={classes.lastCol}
          >
            <SingleFieldList>
              <ChipField source="name" style={{ marginBottom: '15px' }} />
            </SingleFieldList>
          </ReferenceArrayField>
        )}
        <AppEditButton />
      </AppDatagrid>
    </AppList>
  );
};

export default LinkList;
